<template>
	<div class="h100 analyze_left">
		<div class="title">{{ tabTitle === 0 || tabTitle === 1 ? '材料选择' : '工种选择'}}</div>
		<div class="content">
			<div class="checkbox_title">
				<div class="checkbox_title_left">
					<div class="fold"
						 @click="boxshow = !boxshow">
						<i :class="[boxshow?'up':'down']"
						   class="el-icon-arrow-down"></i>
					</div>
					<el-checkbox :indeterminate="isIndeterminate"
								 class="allCheck"
								 v-model="checkAll"
								 @change="handleCheckAllChange">{{ tabTitle === 0 || tabTitle === 1 ? '主要材料' : '主要工种'}}
					</el-checkbox>
				</div>
				<div class="checkbox_title_right">
					<span>{{checkedCities.length}}/{{selects.length}}</span>
					<i v-if="tabTitle === 0 || tabTitle === 1"
					   @click="changeAdd"
					   class="el-icon-circle-plus"></i>
				</div>
			</div>
			<transition name="toTop"
						class="toTop">
				<el-checkbox-group v-model="checkedCities"
								   v-show="boxshow"
								   @change="handleCheckedCitiesChange">
					<div class="children">
						<el-checkbox v-for="(item,index) in selects"
									 class="checkbox-list"
									 :label="item"
									 :key="item"><i class="el-icon-error icon-list"
							   @click.stop.prevent="deleteChange(checkAllList[index])"></i> {{item}}</el-checkbox>
					</div>
				</el-checkbox-group>
			</transition>
		</div>
		<!-- Modal -->
		<el-dialog :title="dialogObj.title"
				   :visible.sync="dialogObj.visible"
				   :width="dialogObj.width"
				   :close-on-click-modal="false"
				   @closed="handleClose">
			<!-- 内容区域 -->
			<div class="h100 overflow-hidden">
				<add-materials ref="materialsAdd"
							   v-if="dialogObj.type === 'add'"
							   @onSave="handleClose"></add-materials>
			</div>

			<!-- 底部按钮 -->
			<div slot="footer"
				 v-if="dialogObj.type === 'add'"
				 class="dialog-footer text-center">
				<el-button @click="handleClose"
						   size="small">取 消</el-button>
				<el-button type="primary"
						   size="small"
						   :loading="btnLoading"
						   @click="doConfirm">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script>
import addMaterials from '../components/addMaterials'
import { getMainMaterials } from '@/api/modules/analyze_tab'
import { saveMainMaterials } from '@/api/modules/resource.js'
export default {
	components: { addMaterials },
	name: 'Regional_analysis_Materials_Left',
	props: {
		tabTitle: {
			type: Number,
			default: null
		}
	},
	data() {
		return {
			checkedCount: 0,
			boxshow: true,
			activeName: '1',
			checkAll: false,
			checkedCities: [],
			checkAllList: [],
			selects: [],
			selectsCode: [],
			isIndeterminate: true,
			dialogObj: {
				title: '添加主要材料',
				visible: false,
				width: '80%',
				type: 'add'
			},
			btnLoading: false
		}
	},
	created() {},
	mounted() {
		this.$nextTick(() => {
			this.getProfessions()
		})
	},
	methods: {
		//初始化数据
		getProfessions() {
			let that = this
			getMainMaterials({ type: 1 })
				.then(res => {
					if (res.code === 0 && res.data != []) {
						let checkAllList = []
						checkAllList = res.data
						this.checkAllList = checkAllList
						this.selects = checkAllList.map(val => {
							return val.sname
						})
						if (this.selects.length !== 0) {
							that.checkedCities = []
							that.checkedCities.push(this.selects[0])
						} else {
							that.checkedCities = []
						}

						this.selectsCode = this.checkAllList
							.filter(v => {
								return that.checkedCities.includes(v.sname)
							})
							.map(function(v) {
								if(v.code!='') return {type:'code', value:v.code}
								else return {type:'id', value:v.id}
							})
					} else {
						this.$message.console.error(res.msg)
					}
				})
				.catch(err => {})
		},

		//全选
		handleCheckAllChange(val) {
			let that = this
			this.checkedCities = val ? this.selects : []
			this.isIndeterminate = false

			this.checkedCount = this.checkedCities.length

			let checkedList = this.checkAllList.filter(v => {
				return that.checkedCities.includes(v.sname)
			})
			this.selectsCode = checkedList.map(function(v) {
				if(v.code!='') return {type:'code', value:v.code}
                else return {type:'id', value:v.id}
			})

		},

		//单选
		handleCheckedCitiesChange(value) {
			let checkedCount = value.length
			this.checkedCount = checkedCount
			this.checkAll = checkedCount === this.selects.length
			this.isIndeterminate =
				checkedCount > 0 && checkedCount < this.selects.length

			let that = this
			let array = that.checkedCities.concat()
			let arr = array.filter(item => !value.some(ele => ele == item))
			if (arr.length != 0) array = array.concat(arr)
			that.checkedCities = array.concat()
			let checkedList = this.checkAllList.filter(v => {
				return that.checkedCities.includes(v.sname)
			})
			this.selectsCode = checkedList.map(function(v) {
				if(v.code!='') return {type:'code', value:v.code}
                else return {type:'id', value:v.id}
			})
		},

		//点击添加材料
		changeAdd() {
			this.dialogObj.type = 'add'
			this.dialogObj.visible = true
		},

		// 弹窗关闭事件
		handleClose() {
			this.dialogObj.visible = false
			this.btnLoading = false
			this.dialogObj.type = ''
		},

		// 弹窗确认事件
		doConfirm() {
			this.btnLoading = true
			this.$refs.materialsAdd.doSubmit()
			setTimeout(() => {
				this.getProfessions()
			}, 300)
		},
		//删除
		deleteChange(delval) {
			let _index = this.checkAllList.findIndex(
				item => item.id === delval.id
			)

			if (_index > -1) {
				this.checkAllList.splice(_index, 1)
			}
			let arrId = []
			this.checkAllList.map(item => {
				arrId.push(item.id)
			})
			saveMainMaterials({
				type: 1, // 1 是材料 2是人工
				resourceIds: arrId
			})
				.then(res => {
					this.$message.success('删除成功!')
					// 保存成功刷新数据
					setTimeout(() => {
						this.getProfessions()
					}, 300)
				})
				.catch(err => {})
		}
	},
	computed: {},
	watch: {
		selectsCode: {
			handler(val) {
				this.$emit('on-codes', val)
			},
			deep: true
		},
	}
}
</script>
<style scoped lang="less">
.analyze_left {
	position: relative;
	padding-top: 30px;
	height: 100%;
	box-sizing: border-box;
	overflow: hidden;
	.title {
		position: absolute;
		top: 0;
		left: 0;
		padding: 0 10px;
		width: 100%;
		height: 30px;
		line-height: 30px;
		color: #333;
		font-size: 18px;
		font-weight: bold;
	}

	.content {
		height: 100%;
		overflow: auto;
		.checkbox_title {
			display: flex;
			background: #ecf5fb;
			line-height: 33px;
			padding: 0 10px;

			.checkbox_title_left {
				flex: 1;
				color: #606266;
				.fold {
					display: inline-block;
					height: 100%;
					padding: 0 10px 0 0;
					cursor: pointer;
					.up {
						transition: all 0.5s;
					}

					.down {
						transform: rotate(-90deg);
						transition: all 0.5s ease;
					}
				}
			}
			.checkbox_title_right {
				flex: 1;
				text-align: right;
				cursor: pointer;
				span {
					color: rgb(102, 102, 102);
					font-size: 14px;
				}
				i {
					color: #ef9200;
					font-size: 18px;
					vertical-align: middle;
				}
			}
		}
	}
}
</style>